import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { DiscountAlert } from '../../DiscountKey';
import { useHistory } from 'react-router';
import { useUserIsStripeCustomer } from '../../../hooks/useUserIsStripeCustomer';
import { getTranslationKey } from '../../../modules/utils/helpers';

interface ModalData {
  addon?: boolean | string;
  [key: string]: any;
}

interface UpgradeAccountModalProps {
  isOpen: boolean;
  digistore: any;
  modalData: ModalData;
  setModalOpenState: (data: { key: string; state: boolean; modalData?: ModalData }) => void;
}

const UpgradeAccountModal: React.FC<UpgradeAccountModalProps> = ({
  isOpen,
  setModalOpenState,
  modalData
}) => {
  const { addon, templateId } = modalData;
  // Opened for a paid template the photographer hasn't bought yet.
  const isTemplatePurchase = addon === 'template' && Boolean(templateId);
  const history = useHistory();
  const userIsStripeCustomer = useUserIsStripeCustomer();

  // `modalData` is merged, never replaced, and most callers open this popup without any — so clear
  // what this open set, or the next open shows the template variant for a non-template action.
  const close = () =>
    setModalOpenState({
      key: 'upgradeModal',
      state: false,
      modalData: { addon: null, templateId: null }
    });

  const onClick = () => {
    close();
    if (userIsStripeCustomer && addon) {
      setModalOpenState({ key: 'updateAddonsModal', state: true, modalData });
    } else {
      history.push('/subscription/pricing');
    }
  };

  return (
    <Modal centered isOpen={isOpen} toggle={close} wrapClassName="modal-dark" size="sm">
      <ModalHeader toggle={close}>
        {getTranslationKey(isTemplatePurchase ? 'unlockTemplate' : 'upgradeAccount')}
      </ModalHeader>
      <ModalBody>
        <p>{getTranslationKey(isTemplatePurchase ? 'unlockTemplateHint' : 'upgradeAccountHint')}</p>

        <Button
          data-cy="UpgradeAccountButton"
          className="w-100-p"
          color="success"
          onClick={onClick}
        >
          {getTranslationKey(isTemplatePurchase ? 'purchaseTemplate' : 'upgradeAccount')}
        </Button>

        <DiscountAlert
          className="cursor-pointer m-t-30 mb-0"
          utm_medium="upgrade-popup-discount-alert"
          afterClick={close}
        />
      </ModalBody>
    </Modal>
  );
};

function mapStateToProps({ auth: { digistore }, modals: { upgradeModal, modalData } }: any) {
  return { isOpen: upgradeModal, digistore, modalData };
}

export default connect(mapStateToProps, actions)(UpgradeAccountModal);
